// import EmailRecoveryMethod from '../../screens/PublicLayout/ForgotPassword/EmailRecoveryMethod.component';
// import ForgetPassword from '../../screens/PublicLayout/ForgotPassword/ForgetPassword.component';
// import PasswordRecoveryMethod from '../../screens/PublicLayout/ForgotPassword/PasswordRecoveryMethod.component';
// import SmsRecoveryMethod from '../../screens/PublicLayout/ForgotPassword/SmsRecoveryMethod.component';
import Login from '../../screens/PublicLayout/Login';

// import RecoverPassword from '../../screens/PublicLayout/RecoverPassword/RecoverPassword.component';
// import Register from '../../screens/PublicLayout/Register';

export const routes = [
  // {
  //   path: '/login',
  //   component: Login,
  // },
  // {
  //   path: '/forgot-password',
  //   component: ForgetPassword,
  // },
  // {
  //   path: '/password-recovery-method',
  //   component: PasswordRecoveryMethod,
  // },
  // {
  //   path: '/email-recovery-method',
  //   component: EmailRecoveryMethod,
  // },
  // {
  //   path: '/sms-recovery-method',
  //   component: SmsRecoveryMethod,
  // },
  // {
  //   path: '/recover-password/:token',
  //   component: RecoverPassword,
  // },
  // {
  //   path: '/sign-up',
  //   component: Register,
  // },
  // {
  //   path: '/recovery',
  //   component: RecoveryNext,
  // },
  // {
  //   path: '/verify/:token',
  //   component: VerifyNext,
  // },

  {
    path: '/',
    component: Login,
  },
  {
    path: '',
    // redirect: '/login',
    redirect: '/',
    component: Login,
  },
];
